// @flow

import Switchers from './switchers';
import { default as SwitchersTemplate } from './template/index.html';

export { SwitcherItem, SwitcherArgs } from './switchers';

export const COMPONENTS_SWITCHERS_NAME = 'switchers';

export const COMPONENTS_SWITCHERS_ENTITIES = [
	{
		name: COMPONENTS_SWITCHERS_NAME,
		entity: Switchers,
		template: SwitchersTemplate,
	},
];
